import React from 'react';
import PropTypes from 'prop-types';

import RichText from 'components/Core/RichText';

const ActivityDesc = ({ activityDesc, activityDescTitle }) => {
  return (
    <div className="my-6 lg:mt-12 lg:mb-10" data-test-id="component-activityDesc">
      <h2 className="h3 pb-8 break-normal">{activityDescTitle}</h2>
      <RichText blockMargin={false} content={activityDesc} />
    </div>
  );
};

ActivityDesc.propTypes = {
  activityDesc: PropTypes.string.isRequired,
  activityDescTitle: PropTypes.string.isRequired,
};

export default ActivityDesc;
